export interface ApiResponse<T> {
  status: number;
  ok: boolean;
  result: T | { data: T };
}

export const hasDataProperty = <T>(obj: T | { data: T }): obj is { data: T } =>
  (obj as { data: T }).data !== undefined;
